import React, { useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import { colorPens } from '../utils/colors';

const RecipeCard = (props) => {
    const [isMouseOver, setIsMouseOver] = useState(false);

    let imageNumber = Math.floor((Math.random() * 20) + 1);
    let sampleImageSrc = process.env.PUBLIC_URL + `/images/sample_thumbnails/${imageNumber}.jpg`;
    let targetLink = () => { alert(`will open a tab for ${props.link}`); };

    if (!window.location.href.startsWith("http://localhost") &&
        !window.location.href.startsWith("https://rush.beadmeer.com")) {
        sampleImageSrc = props.image;
        targetLink = () => { 
            // Google Ads website traffic conversion
            window.gtag('event', 'conversion', { 'send_to': 'AW-967713999/m9F6CJ72zowDEM_JuM0D' });

            // Google Analytics event
            window.gtag('event', "interact", {
                send_to: ['G-R32TQ4L14R'],
                event_category: "search",
                event_action: "refer",
                event_label: "link",
                value: props.link
            });
    
            window.location.href = props.link; 
        };
    }
    // let sampleImageSrc = props.image;

    // function changeBackground(e, color) {
    //     // e.target.style.background = 'red';
    //     e.target.style.background = color;
    // }

    // function showBorder(e) {
    //     // e.target.style.background = 'red';
    //     // e.target.style.background = color;
    //     e.target.style.border = '1px solid';
    // }

    return (
        <Container fluid>
            <div style={{
                // 'border': isMouseOver ? '1px solid' : '0px',
                // 'padding': isMouseOver ? '5px' : '0px',
                // 'background': isMouseOver ? '#f5f5f5' : 'white',
                'outline': isMouseOver ? '1px solid #505050' : ''
            }}>
                <Row className="justify-content-center align-items-center"
                    onClick={targetLink}
                    onMouseEnter={() => setIsMouseOver(true)}
                    onMouseLeave={() => setIsMouseOver(false)}
                >
                    <Col md={3} style={{
                        'background': '#ffffff'
                    }}>
                        {/* <Image src={props.image} style={{ height: 150 }} rounded />*/}
                        <Image src={sampleImageSrc} style={{ height: 150 }} rounded fluid />
                    </Col>
                    <Col md={9} align="left">
                        <span style={{ fontSize: '1.1em', fontWeight: 500 }}>{props.title}</span><br />
                        <span style={{ fontSize: '0.8em', color: colorPens.dark }}>{(props.author !== undefined) ? ' Author: ' + props.author : null}</span>
                        <div>{(props.description !== undefined && props.description !== 'undefined') ? props.description : null}</div>
                    </Col>
                </Row>
            </div>
            <br />
        </Container>
    );
}

export default RecipeCard;